import React from 'react';
import { Calculator, Info } from 'lucide-react';

/**
 * Компонент выбора метода расчета максимального пульса
 */
const CalculationMethodSection = ({
  formData,
  handleInputChange,
  errors,
  maxHRMethods
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Calculator className="w-5 h-5 mr-2 text-gray-500" />
        Метод расчета максимального пульса
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Выберите формулу для расчета
          </label>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            {maxHRMethods.map((method) => (
              <label
                key={method.id}
                className={`relative flex items-center p-3 border rounded-lg cursor-pointer transition-colors
                  ${formData.calculationMethod === method.id 
                    ? 'bg-red-50 border-red-200 dark:bg-red-900/20 dark:border-red-700' 
                    : 'bg-white dark:bg-gray-700 border-gray-200 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600'}`
                }
              >
                <input
                  type="radio"
                  name="calculationMethod"
                  value={method.id}
                  checked={formData.calculationMethod === method.id}
                  onChange={handleInputChange}
                  className="form-radio hidden"
                />
                <div>
                  <p className={`text-sm font-medium 
                    ${formData.calculationMethod === method.id 
                      ? 'text-red-700 dark:text-red-300' 
                      : 'text-gray-700 dark:text-gray-300'}`
                  }>
                    {method.name}
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                    {method.description}
                  </p>
                </div>
              </label>
            ))}
          </div>
          {errors.calculationMethod && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.calculationMethod}
            </p>
          )}
        </div>
      </div>

      {/* Информация о формулах */}
      <div className="mt-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg p-3">
        <div className="flex items-start">
          <Info className="text-blue-500 dark:text-blue-400 w-5 h-5 mr-3 mt-0.5 flex-shrink-0" />
          <div className="text-sm text-blue-700 dark:text-blue-300">
            <p className="font-medium mb-1">О формулах расчета максимального пульса:</p>
            <ul className="list-disc pl-5 text-xs space-y-1">
              <li><strong>Формула Танака (2001)</strong>: 208 - 0.7 × возраст. Современная и точная формула, учитывающая последние исследования.</li>
              <li><strong>Классическая формула (Fox & Haskell, 1970)</strong>: 220 - возраст. Простая и широко используемая, но менее точная у взрослых старше 40 лет.</li>
              <li><strong>Формула Норвежского университета (2012)</strong>: 211 - 0.64 × возраст. Разработана на основе исследований HUNT Fitness Study.</li>
              <li><strong>Формула Геллиша (2007)</strong>: 207 - 0.7 × возраст. Рекомендуется для тренированных людей, особенно спортсменов.</li>
            </ul>
            <p className="text-xs mt-2">
              В российских спортивных и медицинских учреждениях чаще используется формула Танака как наиболее современная и точная.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalculationMethodSection;